// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProductsLayout_titleBack__pdWIm {
  display: flex;
  align-items: center;
}
@media (min-width: 1200px) {
  .ProductsLayout_titleBack__pdWIm {
    margin-bottom: 31px;
  }
}
.ProductsLayout_titleBack__back__OBLG2 {
  height: 36px;
  width: 36px;
  min-width: 36px;
  border-radius: 50%;
  background: var(--white);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: var(--transition);
  transition-property: background, box-shadow;
}
@media (hover: hover) {
  .ProductsLayout_titleBack__back__OBLG2:hover {
    box-shadow: -8px 0px 24px 0px rgba(0, 0, 0, 0.2);
  }
}
@media (min-width: 640px) {
  .ProductsLayout_titleBack__back__OBLG2 {
    width: 52px;
    height: 52px;
  }
}
@media (min-width: 1200px) {
  .ProductsLayout_titleBack__back__OBLG2 {
    width: 28px;
    height: 28px;
    min-width: auto;
    flex-shrink: 0;
    box-shadow: -8px 0px 24px 0px rgba(0, 0, 0, 0.0901960784);
  }
}
.ProductsLayout_titleBack__text__VomNS {
  margin-left: 16px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: var(--transition);
}
@media (min-width: 1200px) {
  .ProductsLayout_titleBack__text__VomNS {
    margin-left: 8px;
  }
}

.ProductsLayout_roomLayout__hero__ZGawt {
  padding: 16px 16px 28px;
  position: relative;
  min-height: 72px;
  max-height: 194px;
  z-index: 2;
  position: fixed;
  width: 100%;
  height: 100%;
  max-width: 800px;
}
.ProductsLayout_roomLayout__hero_hidden__gk7Af .ProductsLayout_roomLayout__hero-head__tdyIq,
.ProductsLayout_roomLayout__hero_hidden__gk7Af .ProductsLayout_roomLayout__hero-bottom__GbiAg {
  height: 0;
  opacity: 0;
}
.ProductsLayout_roomLayout__hero_hidden__gk7Af .ProductsLayout_roomLayout__hero-title__p8MYl {
  margin-top: 8px;
  margin-bottom: 0;
}
.ProductsLayout_roomLayout__hero-content__L2Tpo {
  position: relative;
  z-index: 2;
}
.ProductsLayout_roomLayout__hero-content-flex__q7cmn {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  padding-right: 40px;
}
.ProductsLayout_roomLayout__hero-content-flex__q7cmn .ProductsLayout_roomLayout__hero-title__p8MYl {
  margin: 7px 0;
  -webkit-line-clamp: 1;
  word-break: break-all;
}
.ProductsLayout_roomLayout__hero-content-flex__q7cmn .ProductsLayout_header__logo__yip7t {
  position: absolute;
  right: 0;
}
.ProductsLayout_roomLayout__hero-head__tdyIq {
  height: 36px;
  overflow: hidden;
  transition: 0.3s;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}
.ProductsLayout_roomLayout__hero-head__tdyIq .ProductsLayout_header__logo__yip7t {
  height: 36px;
}
.ProductsLayout_roomLayout__hero-head__tdyIq .ProductsLayout_header__logo__yip7t a {
  height: 36px;
  display: block;
}
.ProductsLayout_roomLayout__hero-head__tdyIq .ProductsLayout_header__logo__yip7t img {
  max-height: 36px;
  max-width: 200px;
}
.ProductsLayout_roomLayout__hero-head__tdyIq .ProductsLayout_header__logo__container__KY72r svg,
.ProductsLayout_roomLayout__hero-head__tdyIq .ProductsLayout_header__logo__container__KY72r img {
  width: auto;
  max-height: 36px;
}
.ProductsLayout_roomLayout__hero-title__p8MYl {
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  color: #fff;
  margin-top: 17px;
  margin-bottom: 17px;
  transition: 0.15s;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ProductsLayout_roomLayout__hero-bottom__GbiAg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  transition: 0.3s;
  overflow: hidden;
}
.ProductsLayout_roomLayout__hero-back__Xios\\+ {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: rgba(25, 25, 25, 0.82);
}
.ProductsLayout_roomLayout__hero-back__Xios\\+ img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.ProductsLayout_roomLayout__hero-back__Xios\\+::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #191919 0%, rgba(25, 25, 25, 0.26) 41.06%, rgba(25, 25, 25, 0.92) 100%);
}
.ProductsLayout_roomLayout__hero-call__NAGf1 {
  width: 40px;
  height: 40px;
  background: #fff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ProductsLayout_roomLayout__searchBlock__OGLXL {
  min-height: 69px;
  z-index: 3;
  position: absolute;
  bottom: -56px;
  width: 100%;
  border-radius: 16px 16px 0 0;
  background-color: #fafafa;
  transition: all 0.15s ease;
}
@media (min-width: 640px) {
  .ProductsLayout_roomLayout__searchBlock__OGLXL {
    min-height: 96px;
  }
}
.ProductsLayout_roomLayout__searchBlock_hidden__j7BQW {
  opacity: 0;
  visibility: hidden;
}
.ProductsLayout_roomLayout__search__eEnBT {
  margin: 15px auto 18px auto;
  width: 91%;
}
.ProductsLayout_roomLayout__search__eEnBT input {
  border-radius: 86px;
}
.ProductsLayout_roomLayout__roomServicesList__sGyYj {
  margin-top: 20px;
}
.ProductsLayout_roomLayout__content__Gq5UR {
  position: relative;
  background: #fafafa;
  padding: 1px 16px 0;
  margin-top: 248px;
}
@media (min-width: 640px) {
  .ProductsLayout_roomLayout__content_firstPage__CPYJV {
    padding-left: 24px !important;
    padding-right: 24px !important;
  }
}
.ProductsLayout_roomLayout__cats__18K6G {
  width: calc(100% + 32px);
  max-width: 800px;
  position: sticky;
  z-index: 2;
  top: 0;
  margin-left: -16px;
  height: auto;
}
@media (min-width: 640px) {
  .ProductsLayout_roomLayout__cats__18K6G {
    margin-left: -24px;
    width: calc(100% + 48px);
  }
}
@media (min-width: 1200px) {
  .ProductsLayout_roomLayout__cats__18K6G {
    position: sticky;
    top: var(--header-height);
    max-width: none;
    margin-left: 0;
    width: 100%;
  }
}
@media (min-width: 1200px) {
  .ProductsLayout_roomLayout__cats--fixed__I2MZs {
    border-bottom: 1px solid #b3b8bb;
  }
}
.ProductsLayout_roomLayout__cats__18K6G .slider-nav {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.ProductsLayout_roomLayout__catsWp__Wjlpa {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}
.ProductsLayout_roomLayout__catsWp__Wjlpa::before {
  content: "";
  position: absolute;
  left: -20px;
  right: -20px;
  top: 0;
  bottom: 0;
  background-color: #F6F7F8;
  display: none;
}
@media (min-width: 1200px) {
  .ProductsLayout_roomLayout__catsWp__Wjlpa::before {
    display: block;
  }
}
.ProductsLayout_roomLayout__catsWp__Wjlpa > div {
  width: 100%;
  z-index: 2;
  padding: 24px 16px;
  background: #fafafa;
}
@media (min-width: 1200px) {
  .ProductsLayout_roomLayout__catsWp__Wjlpa > div {
    background: none;
    padding: 16px 0;
  }
}
.ProductsLayout_roomLayout__catsWp__Wjlpa > div > div {
  width: 100%;
}
.ProductsLayout_roomLayout__catsWp__Wjlpa > div.ProductsLayout_nav__ypedQ {
  z-index: 3;
}
.ProductsLayout_roomLayout__catsWp__Wjlpa > div::-webkit-scrollbar {
  height: 0;
}
.ProductsLayout_roomLayout__catsWrap__AVtET {
  width: 100%;
  background: #fafafa;
  padding: 0;
  display: flex;
  font-size: var(--fz-md);
  overflow-x: scroll;
  position: relative;
}
@media (min-width: 640px) {
  .ProductsLayout_roomLayout__catsWrap__AVtET {
    font-size: 22px;
  }
}
@media (min-width: 1200px) {
  .ProductsLayout_roomLayout__catsWrap__AVtET {
    font-size: var(--fz-md);
    line-height: var(--lh-md);
    overflow: initial;
    background: none;
  }
}
.ProductsLayout_roomLayout__catsWrap__AVtET::before {
  display: none;
}
.ProductsLayout_roomLayout__catsWrap__AVtET .swiper-slide {
  width: auto;
}
.ProductsLayout_roomLayout__catsWrap-anchor__Y7oX0 {
  padding: 8px 20px;
  border-radius: 12px;
  line-height: 100%;
  cursor: pointer;
}
@media (min-width: 640px) {
  .ProductsLayout_roomLayout__catsWrap-anchor__Y7oX0 {
    padding: 16px 36px;
    border-radius: 25px;
  }
}
@media (min-width: 1200px) {
  .ProductsLayout_roomLayout__catsWrap-anchor__Y7oX0 {
    border-radius: 12px;
    padding: 8px 20px;
  }
}
.ProductsLayout_roomLayout__catsWrap-anchor__Y7oX0 div {
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
  display: block;
  transition: all 0.3s;
  opacity: 0.5;
  outline: none;
  text-decoration: none;
}
@media (hover: hover) {
  .ProductsLayout_roomLayout__catsWrap-anchor__Y7oX0:hover div {
    opacity: 1;
  }
}
.ProductsLayout_roomLayout__catsWrap-anchor-active__fm6ia {
  background: #eee;
}
.ProductsLayout_roomLayout__catsWrap-anchor-active__fm6ia div {
  opacity: 1;
}
.ProductsLayout_roomLayout__catsWrap__AVtET::-webkit-scrollbar {
  width: 12px;
}
.ProductsLayout_roomLayout__empty__MYEuT {
  margin-top: 30px;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 114%;
  color: var(--text-color);
  min-height: 30vh;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (min-width: 640px) {
  .ProductsLayout_roomLayout__hero__ZGawt {
    padding: 36px 24px 52px;
    min-height: 160px;
    max-height: 354px;
  }
  .ProductsLayout_roomLayout__hero-head__tdyIq {
    height: 52px;
  }
  .ProductsLayout_roomLayout__hero-title__p8MYl {
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: 44px;
    margin-top: 24px;
    margin-bottom: 24px;
  }
  .ProductsLayout_roomLayout__hero-bottom__GbiAg {
    height: 79px;
  }
  .ProductsLayout_roomLayout__hero-call__NAGf1 {
    width: 78px;
    height: 78px;
    border-radius: 25px;
  }
  .ProductsLayout_roomLayout__hero-call__NAGf1 svg {
    width: 42px;
    height: 42px;
  }
  .ProductsLayout_roomLayout__content__Gq5UR {
    margin-top: 346px;
  }
  .ProductsLayout_roomLayout__content__Gq5UR::before {
    height: 25px;
    top: -24px;
    border-radius: 24px 24px 0px 0px;
  }
  .ProductsLayout_roomLayout__searchBlock__OGLXL {
    border-radius: 24px 24px 0 0;
  }
  .ProductsLayout_roomLayout__hero-content-flex__q7cmn .ProductsLayout_roomLayout__hero-title__p8MYl {
    margin: 4px 0;
  }
  .ProductsLayout_roomLayout__empty__MYEuT {
    font-size: 22px;
  }
}
@media (min-width: 1200px) {
  .ProductsLayout_roomLayout__searchList__oZNPK:first-child {
    margin-top: 0;
  }
}

.ProductsLayout_openBlock__So3u8 {
  background: #fff;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 3px 16px 3px 10px;
  border-radius: 12px;
}
.ProductsLayout_openBlock__ico__ZbeE2 {
  width: 20px;
  min-width: 20px;
  height: 20px;
  background: #41c061;
  border: 5px solid #c7edd0;
  border-radius: 50%;
}
.ProductsLayout_openBlock__ico__ZbeE2.ProductsLayout_red__SAiY- {
  background: var(--error);
  border-color: #f87f7f;
}
.ProductsLayout_openBlock__text__wDgtB {
  margin-left: 8px;
}
.ProductsLayout_openBlock__text__wDgtB p {
  color: #000;
  font-weight: 600;
}
.ProductsLayout_openBlock__text__wDgtB span {
  display: block;
  margin-top: 2px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
  letter-spacing: -0.24px;
  color: #4b5058;
}
@media (min-width: 640px) {
  .ProductsLayout_openBlock__So3u8 {
    padding: 12px 32px 12px 19px;
    border-radius: 20px;
    height: 78px;
  }
  .ProductsLayout_openBlock__ico__ZbeE2 {
    width: 44px;
    height: 44px;
    border-width: 12px;
  }
  .ProductsLayout_openBlock__text__wDgtB p {
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
  }
  .ProductsLayout_openBlock__text__wDgtB span {
    font-size: 22px;
    letter-spacing: -0.44px;
    margin-top: 4px;
  }
}

.ProductsLayout_titleTechObj__LhzI0,
.ProductsLayout_techObj__hX0Hg {
  margin-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/TitleBack/TitleBack.module.scss","webpack://./src/components/ProductsLayout/ProductsLayout.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;ACCF;ADCE;EAJF;IAKI,mBAAA;ECEF;AACF;ADAE;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,wBAAA;EACA,2CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,6BAAA;EACA,2CAAA;ACEJ;ADAI;EACE;IACE,gDAAA;ECEN;AACF;ADCI;EApBF;IAqBI,WAAA;IACA,YAAA;ECEJ;AACF;ADAI;EAzBF;IA0BI,WAAA;IACA,YAAA;IACA,eAAA;IACA,cAAA;IACA,yDAAA;ECGJ;AACF;ADAE;EACE,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,6BAAA;ACEJ;ADAI;EATF;IAUI,gBAAA;ECGJ;AACF;;AArDE;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAwDJ;AArDM;;EAEE,SAAA;EACA,UAAA;AAuDR;AApDM;EACE,eAAA;EACA,gBAAA;AAsDR;AAjDE;EACE,kBAAA;EACA,UAAA;AAmDJ;AAhDE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AAkDJ;AAhDI;EACE,aAAA;EACA,qBAAA;EACA,qBAAA;AAkDN;AA/CI;EACE,kBAAA;EACA,QAAA;AAiDN;AA7CE;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;AA+CJ;AA7CI;EACE,YAAA;AA+CN;AA7CM;EACE,YAAA;EACA,cAAA;AA+CR;AA5CM;EACE,gBAAA;EACA,gBAAA;AA8CR;AA1CQ;;EAEE,WAAA;EAEA,gBAAA;AA2CV;AArCE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAuCJ;AApCE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AAsCJ;AAnCE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;AAqCJ;AAnCI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AAqCN;AAlCI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,2GAAA;AAoCN;AAhCE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAkCJ;AA/BE;EACE,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,4BAAA;EACA,yBAAA;EACA,0BAAA;AAiCJ;AAhCI;EATF;IAUI,gBAAA;EAmCJ;AACF;AAlCI;EACE,UAAA;EACA,kBAAA;AAoCN;AAhCE;EACE,2BAAA;EACA,UAAA;AAkCJ;AAjCI;EACE,mBAAA;AAmCN;AAhCE;EACE,gBAAA;AAkCJ;AA/BE;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AAiCJ;AA9BI;EADF;IAEI,6BAAA;IACA,8BAAA;EAiCJ;AACF;AA9BE;EAEE,wBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,MAAA;EACA,kBAAA;EACA,YAAA;AA+BJ;AA7BI;EAVF;IAWI,kBAAA;IACA,wBAAA;EAgCJ;AACF;AA9BI;EAfF;IAgBI,gBAAA;IACA,yBAAA;IACA,eAAA;IACA,cAAA;IACA,WAAA;EAiCJ;AACF;AA9BM;EADF;IAEI,gCAAA;EAiCN;AACF;AA7BM;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;AA+BR;AA1BE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AA4BJ;AA1BI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;AA4BN;AA1BM;EAVF;IAWI,cAAA;EA6BN;AACF;AA1BI;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;AA4BN;AA1BM;EANF;IAOI,gBAAA;IACA,eAAA;EA6BN;AACF;AA3BM;EACE,WAAA;AA6BR;AA1BM;EACE,UAAA;AA4BR;AAzBM;EACE,SAAA;AA2BR;AAtBE;EACE,WAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAwBJ;AAtBI;EATF;IAUI,eAAA;EAyBJ;AACF;AAvBI;EAbF;IAcI,uBAAA;IACA,yBAAA;IACA,iBAAA;IACA,gBAAA;EA0BJ;AACF;AAxBI;EACE,aAAA;AA0BN;AAtBM;EACE,WAAA;AAwBR;AApBI;EACE,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAsBN;AApBM;EANF;IAOI,kBAAA;IACA,mBAAA;EAuBN;AACF;AArBM;EAXF;IAYI,mBAAA;IACA,iBAAA;EAwBN;AACF;AAtBM;EACE,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,YAAA;EACA,aAAA;EAEA,qBAAA;AAuBR;AApBM;EAEI;IACE,UAAA;EAqBV;AACF;AAjBM;EACE,gBAAA;AAmBR;AAjBQ;EACE,UAAA;AAmBV;AAdI;EACE,WAAA;AAgBN;AAZE;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAcJ;AAXE;EACE;IACE,uBAAA;IACA,iBAAA;IACA,iBAAA;EAaJ;EAVE;IACE,YAAA;EAYJ;EATE;IACE,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,gBAAA;IACA,mBAAA;EAWJ;EARE;IACE,YAAA;EAUJ;EAPE;IACE,WAAA;IACA,YAAA;IACA,mBAAA;EASJ;EAPI;IACE,WAAA;IACA,YAAA;EASN;EALE;IACE,iBAAA;EAOJ;EALI;IACE,YAAA;IACA,UAAA;IACA,gCAAA;EAON;EAJE;IACE,4BAAA;EAMJ;EAFI;IACE,aAAA;EAIN;EAAE;IACE,eAAA;EAEJ;AACF;AAGM;EADF;IAEI,aAAA;EAAN;AACF;;AAKA;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,mBAAA;AAFF;AAIE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAFJ;AAII;EACE,wBAAA;EACA,qBAAA;AAFN;AAME;EACE,gBAAA;AAJJ;AAMI;EACE,WAAA;EACA,gBAAA;AAJN;AAOI;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AALN;AASE;EA1CF;IA2CI,4BAAA;IACA,mBAAA;IACA,YAAA;EANF;EAQE;IACE,WAAA;IACA,YAAA;IACA,kBAAA;EANJ;EAUI;IACE,eAAA;IACA,kBAAA;IACA,gBAAA;EARN;EAWI;IACE,eAAA;IACA,uBAAA;IACA,eAAA;EATN;AACF;;AAcA;;EAEE,mBAAA;AAXF","sourcesContent":[".titleBack {\n  display: flex;\n  align-items: center;\n\n  @media (min-width: 1200px) {\n    margin-bottom: 31px;\n  }\n\n  &__back {\n    height: 36px;\n    width: 36px;\n    min-width: 36px;\n    border-radius: 50%;\n    background: var(--white);\n    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.16);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: var(--transition);\n    transition-property: background, box-shadow;\n\n    @media (hover: hover) {\n      &:hover {\n        box-shadow: -8px 0px 24px 0px rgba(0, 0, 0, 0.2);\n      }\n    }\n\n    @media (min-width: 640px) {\n      width: 52px;\n      height: 52px;\n    }\n\n    @media (min-width: 1200px) {\n      width: 28px;\n      height: 28px;\n      min-width: auto;\n      flex-shrink: 0;\n      box-shadow: -8px 0px 24px 0px #00000017;\n    }\n  }\n\n  &__text {\n    margin-left: 16px;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    transition: var(--transition);\n\n    @media (min-width: 1200px) {\n      margin-left: 8px;\n    }\n  }\n}","@import \"../TitleBack/TitleBack.module\";\r\n\r\n.roomLayout {\r\n  &__hero {\r\n    padding: 16px 16px 28px;\r\n    position: relative;\r\n    min-height: 72px;\r\n    max-height: 194px;\r\n    z-index: 2;\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    max-width: 800px;\r\n\r\n    &_hidden {\r\n      .roomLayout__hero-head,\r\n      .roomLayout__hero-bottom {\r\n        height: 0;\r\n        opacity: 0;\r\n      }\r\n\r\n      .roomLayout__hero-title {\r\n        margin-top: 8px;\r\n        margin-bottom: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  &__hero-content {\r\n    position: relative;\r\n    z-index: 2;\r\n  }\r\n\r\n  &__hero-content-flex {\r\n    display: flex;\r\n    gap: 16px;\r\n    align-items: flex-start;\r\n    padding-right: 40px;\r\n\r\n    .roomLayout__hero-title {\r\n      margin: 7px 0;\r\n      -webkit-line-clamp: 1;\r\n      word-break: break-all;\r\n    }\r\n\r\n    .header__logo {\r\n      position: absolute;\r\n      right: 0;\r\n    }\r\n  }\r\n\r\n  &__hero-head {\r\n    height: 36px;\r\n    overflow: hidden;\r\n    transition: 0.3s;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    flex-shrink: 0;\r\n\r\n    .header__logo {\r\n      height: 36px;\r\n\r\n      a {\r\n        height: 36px;\r\n        display: block;\r\n      }\r\n\r\n      img {\r\n        max-height: 36px;\r\n        max-width: 200px;\r\n      }\r\n\r\n      &__container {\r\n        svg,\r\n        img {\r\n          width: auto;\r\n          // width: 100%;\r\n          max-height: 36px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &__hero-title {\r\n    font-size: 20px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 22px;\r\n    color: #fff;\r\n    margin-top: 17px;\r\n    margin-bottom: 17px;\r\n    transition: 0.15s;\r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 2;\r\n    -webkit-box-orient: vertical;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n\r\n  &__hero-bottom {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    height: 40px;\r\n    transition: 0.3s;\r\n    overflow: hidden;\r\n  }\r\n\r\n  &__hero-back {\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(25, 25, 25, 0.82);\r\n\r\n    img {\r\n      width: 100%;\r\n      height: 100%;\r\n      object-fit: cover;\r\n      object-position: center;\r\n    }\r\n\r\n    &::before {\r\n      content: \"\";\r\n      position: absolute;\r\n      top: 0;\r\n      bottom: 0;\r\n      left: 0;\r\n      right: 0;\r\n      width: 100%;\r\n      height: 100%;\r\n      background: linear-gradient(180deg, #191919 0%, rgba(25, 25, 25, 0.26) 41.06%, rgba(25, 25, 25, 0.92) 100%);\r\n    }\r\n  }\r\n\r\n  &__hero-call {\r\n    width: 40px;\r\n    height: 40px;\r\n    background: #fff;\r\n    border-radius: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  &__searchBlock {\r\n    min-height: 69px;\r\n    z-index: 3;\r\n    position: absolute;\r\n    bottom: -56px;\r\n    width: 100%;\r\n    border-radius: 16px 16px 0 0;\r\n    background-color: #fafafa;\r\n    transition: all 0.15s ease;\r\n    @media (min-width: 640px) {\r\n      min-height: 96px;\r\n    }\r\n    &_hidden {\r\n      opacity: 0;\r\n      visibility: hidden;\r\n    }\r\n  }\r\n\r\n  &__search {\r\n    margin: 15px auto 18px auto;\r\n    width: 91%;\r\n    input {\r\n      border-radius: 86px;\r\n    }\r\n  }\r\n  &__roomServicesList {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  &__content {\r\n    position: relative;\r\n    background: #fafafa;\r\n    padding: 1px 16px 0;\r\n    margin-top: 248px;\r\n  }\r\n  &__content_firstPage {\r\n    @media (min-width: 640px) {\r\n      padding-left: 24px !important;\r\n      padding-right: 24px !important;\r\n    }\r\n  }\r\n\r\n  &__cats {\r\n    //* + 2 паддинга *//\r\n    width: calc(100% + 32px);\r\n    max-width: 800px;\r\n    position: sticky;\r\n    z-index: 2;\r\n    top: 0;\r\n    margin-left: -16px;\r\n    height: auto;\r\n\r\n    @media (min-width: 640px) {\r\n      margin-left: -24px;\r\n      width: calc(100% + 48px);\r\n    }\r\n\r\n    @media (min-width: 1200px) {\r\n      position: sticky;\r\n      top: var(--header-height);\r\n      max-width: none;\r\n      margin-left: 0;\r\n      width: 100%;\r\n    }\r\n\r\n    &--fixed {\r\n      @media (min-width: 1200px) {\r\n        border-bottom: 1px solid #b3b8bb;\r\n      }\r\n    }\r\n\r\n    :global {\r\n      .slider-nav {\r\n        position: absolute;\r\n        left: 0;\r\n        right: 0;\r\n        top: calc(50%);\r\n        transform: translateY(-50%);\r\n      }\r\n    }\r\n  }\r\n\r\n  &__catsWp {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    width: 100%;\r\n    overflow-x: auto;\r\n    overflow-y: hidden;\r\n\r\n    &::before {\r\n      content: '';\r\n      position: absolute;\r\n      left: -20px;\r\n      right: -20px;\r\n      top: 0;\r\n      bottom: 0;\r\n      background-color: #F6F7F8;\r\n      display: none;\r\n\r\n      @media (min-width: 1200px) {\r\n        display: block;\r\n      }\r\n    }\r\n\r\n    & > div {\r\n      width: 100%;\r\n      z-index: 2;\r\n      padding: 24px 16px;\r\n      background: #fafafa;\r\n\r\n      @media (min-width: 1200px) {\r\n        background: none;\r\n        padding: 16px 0;\r\n      }\r\n\r\n      & > div {\r\n        width: 100%;\r\n      }\r\n\r\n      &.nav {\r\n        z-index: 3;\r\n      }\r\n\r\n      &::-webkit-scrollbar {\r\n        height: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  &__catsWrap {\r\n    width: 100%;\r\n    background: #fafafa;\r\n    padding: 0;\r\n    display: flex;\r\n    font-size: var(--fz-md);\r\n    overflow-x: scroll;\r\n    position: relative;\r\n\r\n    @media (min-width: 640px) {\r\n      font-size: 22px;\r\n    }\r\n\r\n    @media (min-width: 1200px) {\r\n      font-size: var(--fz-md);\r\n      line-height: var(--lh-md);\r\n      overflow: initial;\r\n      background: none;\r\n    }\r\n\r\n    &::before {\r\n      display: none;\r\n    }\r\n\r\n    :global {\r\n      .swiper-slide {\r\n        width: auto;\r\n      }\r\n    }\r\n\r\n    &-anchor {\r\n      padding: 8px 20px;\r\n      border-radius: 12px;\r\n      line-height: 100%;\r\n      cursor: pointer;\r\n\r\n      @media (min-width: 640px) {\r\n        padding: 16px 36px;\r\n        border-radius: 25px;\r\n      }\r\n\r\n      @media (min-width: 1200px) {\r\n        border-radius: 12px;\r\n        padding: 8px 20px;\r\n      }\r\n\r\n      div {\r\n        white-space: nowrap;\r\n        text-overflow: ellipsis;\r\n        position: relative;\r\n        display: block;\r\n        transition: all 0.3s;\r\n        opacity: 0.5;\r\n        outline: none;\r\n\r\n        text-decoration: none;\r\n      }\r\n\r\n      @media (hover: hover) {\r\n        &:hover {\r\n          div {\r\n            opacity: 1;\r\n          }\r\n        }\r\n      }\r\n\r\n      &-active {\r\n        background: #eee;\r\n\r\n        div {\r\n          opacity: 1;\r\n        }\r\n      }\r\n    }\r\n\r\n    &::-webkit-scrollbar {\r\n      width: 12px;\r\n    }\r\n  }\r\n\r\n  &__empty {\r\n    margin-top: 30px;\r\n    text-align: center;\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 114%;\r\n    color: var(--text-color);\r\n    min-height: 30vh;\r\n    padding-left: 16px;\r\n    padding-right: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  @media (min-width: 640px) {\r\n    &__hero {\r\n      padding: 36px 24px 52px;\r\n      min-height: 160px;\r\n      max-height: 354px;\r\n    }\r\n\r\n    &__hero-head {\r\n      height: 52px;\r\n    }\r\n\r\n    &__hero-title {\r\n      font-size: 36px;\r\n      font-style: normal;\r\n      font-weight: 700;\r\n      line-height: 44px;\r\n      margin-top: 24px;\r\n      margin-bottom: 24px;\r\n    }\r\n\r\n    &__hero-bottom {\r\n      height: 79px;\r\n    }\r\n\r\n    &__hero-call {\r\n      width: 78px;\r\n      height: 78px;\r\n      border-radius: 25px;\r\n\r\n      svg {\r\n        width: 42px;\r\n        height: 42px;\r\n      }\r\n    }\r\n\r\n    &__content {\r\n      margin-top: 346px;\r\n\r\n      &::before {\r\n        height: 25px;\r\n        top: -24px;\r\n        border-radius: 24px 24px 0px 0px;\r\n      }\r\n    }\r\n    &__searchBlock {\r\n      border-radius: 24px 24px 0 0;\r\n    }\r\n\r\n    &__hero-content-flex {\r\n      .roomLayout__hero-title {\r\n        margin: 4px 0;\r\n      }\r\n    }\r\n\r\n    &__empty {\r\n      font-size: 22px;\r\n    }\r\n  }\r\n\r\n  &__searchList {\r\n    &:first-child {\r\n      @media (min-width: 1200px) {\r\n        margin-top: 0;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.openBlock {\r\n  background: #fff;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 3px 16px 3px 10px;\r\n  border-radius: 12px;\r\n\r\n  &__ico {\r\n    width: 20px;\r\n    min-width: 20px;\r\n    height: 20px;\r\n    background: #41c061;\r\n    border: 5px solid #c7edd0;\r\n    border-radius: 50%;\r\n\r\n    &.red {\r\n      background: var(--error);\r\n      border-color: #f87f7f;\r\n    }\r\n  }\r\n\r\n  &__text {\r\n    margin-left: 8px;\r\n\r\n    p {\r\n      color: #000;\r\n      font-weight: 600;\r\n    }\r\n\r\n    span {\r\n      display: block;\r\n      margin-top: 2px;\r\n      font-size: 12px;\r\n      font-style: normal;\r\n      font-weight: 400;\r\n      line-height: 100%;\r\n      letter-spacing: -0.24px;\r\n      color: #4b5058;\r\n    }\r\n  }\r\n\r\n  @media (min-width: 640px) {\r\n    padding: 12px 32px 12px 19px;\r\n    border-radius: 20px;\r\n    height: 78px;\r\n\r\n    &__ico {\r\n      width: 44px;\r\n      height: 44px;\r\n      border-width: 12px;\r\n    }\r\n\r\n    &__text {\r\n      p {\r\n        font-size: 28px;\r\n        font-style: normal;\r\n        font-weight: 600;\r\n      }\r\n\r\n      span {\r\n        font-size: 22px;\r\n        letter-spacing: -0.44px;\r\n        margin-top: 4px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.titleTechObj,\r\n.techObj {\r\n  margin-bottom: 16px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleBack": `ProductsLayout_titleBack__pdWIm`,
	"titleBack__back": `ProductsLayout_titleBack__back__OBLG2`,
	"titleBack__text": `ProductsLayout_titleBack__text__VomNS`,
	"roomLayout__hero": `ProductsLayout_roomLayout__hero__ZGawt`,
	"roomLayout__hero_hidden": `ProductsLayout_roomLayout__hero_hidden__gk7Af`,
	"roomLayout__hero-head": `ProductsLayout_roomLayout__hero-head__tdyIq`,
	"roomLayout__hero-bottom": `ProductsLayout_roomLayout__hero-bottom__GbiAg`,
	"roomLayout__hero-title": `ProductsLayout_roomLayout__hero-title__p8MYl`,
	"roomLayout__hero-content": `ProductsLayout_roomLayout__hero-content__L2Tpo`,
	"roomLayout__hero-content-flex": `ProductsLayout_roomLayout__hero-content-flex__q7cmn`,
	"header__logo": `ProductsLayout_header__logo__yip7t`,
	"header__logo__container": `ProductsLayout_header__logo__container__KY72r`,
	"roomLayout__hero-back": `ProductsLayout_roomLayout__hero-back__Xios+`,
	"roomLayout__hero-call": `ProductsLayout_roomLayout__hero-call__NAGf1`,
	"roomLayout__searchBlock": `ProductsLayout_roomLayout__searchBlock__OGLXL`,
	"roomLayout__searchBlock_hidden": `ProductsLayout_roomLayout__searchBlock_hidden__j7BQW`,
	"roomLayout__search": `ProductsLayout_roomLayout__search__eEnBT`,
	"roomLayout__roomServicesList": `ProductsLayout_roomLayout__roomServicesList__sGyYj`,
	"roomLayout__content": `ProductsLayout_roomLayout__content__Gq5UR`,
	"roomLayout__content_firstPage": `ProductsLayout_roomLayout__content_firstPage__CPYJV`,
	"roomLayout__cats": `ProductsLayout_roomLayout__cats__18K6G`,
	"roomLayout__cats--fixed": `ProductsLayout_roomLayout__cats--fixed__I2MZs`,
	"roomLayout__catsWp": `ProductsLayout_roomLayout__catsWp__Wjlpa`,
	"nav": `ProductsLayout_nav__ypedQ`,
	"roomLayout__catsWrap": `ProductsLayout_roomLayout__catsWrap__AVtET`,
	"roomLayout__catsWrap-anchor": `ProductsLayout_roomLayout__catsWrap-anchor__Y7oX0`,
	"roomLayout__catsWrap-anchor-active": `ProductsLayout_roomLayout__catsWrap-anchor-active__fm6ia`,
	"roomLayout__empty": `ProductsLayout_roomLayout__empty__MYEuT`,
	"roomLayout__searchList": `ProductsLayout_roomLayout__searchList__oZNPK`,
	"openBlock": `ProductsLayout_openBlock__So3u8`,
	"openBlock__ico": `ProductsLayout_openBlock__ico__ZbeE2`,
	"red": `ProductsLayout_red__SAiY-`,
	"openBlock__text": `ProductsLayout_openBlock__text__wDgtB`,
	"titleTechObj": `ProductsLayout_titleTechObj__LhzI0`,
	"techObj": `ProductsLayout_techObj__hX0Hg`
};
export default ___CSS_LOADER_EXPORT___;
